import { render, staticRenderFns } from "./CompanyOurStory.vue?vue&type=template&id=2e2b0741&scoped=true"
import script from "./CompanyOurStory.vue?vue&type=script&lang=js"
export * from "./CompanyOurStory.vue?vue&type=script&lang=js"
import style0 from "./CompanyOurStory.vue?vue&type=style&index=0&id=2e2b0741&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e2b0741",
  null
  
)

export default component.exports